import { forwardRef } from 'react';
import { classes } from '../../utils/commonUtils';
import css from './badge.module.scss';

export enum BadgeTypes {
  Bought = 'bought',
  Rented = 'rented',
  Price = 'price',
  Expires = 'expires',
  New = 'new',
}

type BadgeVariant = 'primary' | 'success' | 'dark' | 'light' | 'live';

type BadgeSize = 'md' | 'lg';

export interface BadgeProps {
  text: string;
  className?: string;
  type?: `${BadgeTypes}` | BadgeVariant;
  size?: BadgeSize;
  iconLeft?: React.ComponentType<React.SVGProps<SVGSVGElement>> | null;
}

export const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  ({ text, className, type, size = 'md', iconLeft: IconLeft }, ref) => {
    return (
      <div ref={ref} className={classes(css.badge, type && css[type], className)} data-size={size}>
        {IconLeft && <IconLeft className={css.icon} />}
        {text}
      </div>
    );
  },
);

export default Badge;
